var map = {
	"./01.jpg": 18956,
	"./02.jpg": 79579,
	"./03.jpg": 94622,
	"./04.jpg": 41957,
	"./05.jpg": 97992,
	"./06.jpg": 8919,
	"./07.jpg": 37754,
	"./08.jpg": 15105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43210;